import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import useStyles from './NavToTop.styles';
import { get } from 'global/lib/lodash';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

export default function NavToTop(props) {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);
  const [ref, inView] = useInView({});
  const canBeVisible = !('visible' in props) || props.visible;

  useEffect(() => {
    if (!inView && canBeVisible) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [inView, canBeVisible]);

  const onClick = () => {
    const hasClick = get(props, 'onClick');
    if (hasClick) {
      hasClick();
    } else {
      window.scroll(0, 0);
    }
  };

  return (
    <>
      <div ref={ref} id={'navToTop'} />
      <div className={!visible ? classes.hidden : classes.show}>
        <Tooltip title="Scroll To Top">
          <Fab size="small" className={classes.button} onClick={onClick}>
            <KeyboardArrowUpIcon />
          </Fab>
        </Tooltip>
      </div>
    </>
  );
}
